import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function ShipptingRateForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "name",
            label: "RATE NAME",
            type: "money",
            placeholder: "Rate name here",
            required: true,
            size: "small",
            itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
          },
          {
            name: "min_rate",
            label: "Minimum order value",
            type: "money",
            required: true,
            size: "small",
            itemSize: { lg: 4, md: 4, sm: 12, xs: 12 },
          },
          {
            name: "max_rate",
            label: "Maximum order value",
            type: "money",
            required: true,
            size: "small",
            itemSize: { lg: 4, md: 4, sm: 12, xs: 12 },
          },
          {
            name: "rate",
            label: "Rate Price",
            type: "money",
            required: true,
            size: "small",
            itemSize: { lg: 4, md: 4, sm: 12, xs: 12 },
          },
        ]}
        isLabel
        fullWidth={true}
        alignItems="flex-end"
        direction="row"
        spacing={2}
      />
    </div>
  );
});
